import { useEffect, useState } from 'react';

/** Load once (and on `deps` change) with loading/error state. */
export function useLoad<T>(fn: () => Promise<T>, deps: unknown[]) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<unknown>(null);
  const [n, setN] = useState(0);
  useEffect(() => {
    let live = true;
    fn().then(
      (d) => {
        if (live) setData(d);
      },
      (e: unknown) => {
        if (live) setError(e);
      },
    );
    return () => {
      live = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, n]);
  return {
    data,
    error,
    reload: () => {
      setError(null);
      setN((x) => x + 1);
    },
  };
}
